// import config from '../../config';
// import { removeItem } from './localStorageFn';
import { removeAuthToken, removeRefreshToken } from './auth';

const handleApiErrors = (response) => {
  if (!response.ok) {
    if (response.status === 401) {
      throw new Error('Unauthorized');
    }
  }
  return response;
};

const manualLogout = () => {
  removeAuthToken();
  removeRefreshToken();
  // window.location.href = config.Domain;
};

export { handleApiErrors, manualLogout };
